import React, { useEffect, useState, useCallback } from 'react'
import { useSelector } from 'react-redux'
import styled from 'styled-components'
import { useRouteMatch } from "react-router";
import jsonp from 'jsonp';
import { numberFormat } from 'estimate_list/libs/util';

const NaverPowerShopping = (props) => {
    const categoryArr = []
    const categoryData = useSelector(state => state.category.categoryData)


    categoryData.map(cate => {
        if(cate.child_count > 0){
            cate.child.map(cate2 => {
                categoryArr[cate2.cate_id] = cate2.cate_keyword
                if(cate2.child_count > 0){
                    cate2.child.map(cate3 => {
                        categoryArr[cate3.cate_id] = cate3.cate_keyword
                        if(cate3.child_count > 0){
                            cate3.child.map(cate4 => {
                                categoryArr[cate4.cate_id] = cate4.cate_keyword
                                if(cate4.child_count > 0){
                                    cate4.child.map(cate5 => {
                                        categoryArr[cate5.cate_id] = cate5.cate_keyword
                                        return null
                                    })
                                }
                                return null
                            })
                        }
                        return null
                    })
                }
                return null
            })
        }
        categoryArr[cate.cate_id] = cate.cate_keyword
        return null
    })

    const match = useRouteMatch()
    const categoryKey = match.params.categoryID ? match.params.categoryID : '1010100000'
    let keyword = categoryArr[categoryKey]
    const [powerShoppingList, setPowerShoppingList] = useState([])
    const { domain } = useSelector(state => state.initial)
    let channel = ''
    if(domain === 'shopping'){
        channel = "pping.ch4"
    }else{
        channel = "pping.ch6"
    }

    const apiCall = useCallback(async () => {
        const hostName = window.location.hostname
        const pageSize = '6'

        if (keyword) {
            const params = 'channel='+channel+'&channel='+channel+'&pageSize='+pageSize+'&query='+keyword+'&url=http%3A%2F%2F'+hostName
            let adUrl = ''
            if(process.env.REACT_APP_TLD === 'kr') adUrl = 'https://external-api.impression-neo.naver.com'
            else adUrl = 'https://sandbox.impression-neo.naver.com'
            let _url = adUrl + '/api/v2/ads/search-jsonp?' + params

            await jsonp(_url, (error, res) => {
                if (error) {
                    console.log(error)
                } else {
                    setPowerShoppingList(res.ads)
                }
            })
        }
    }, [keyword, channel]);

    useEffect(() => {
        apiCall();
    }, [keyword, apiCall])


    const checkADLoad = () => {

        props.setIsNaverLoadingEnd(true)

    }


    return (
        <div>
            {powerShoppingList ? (
                <Case>
                    <div className='PowerShoppingAdTitle'>
                        <em>파워쇼핑</em>
                        <a href="https://saedu.naver.com/adbiz/searchad/shoppingSa.nhn" target="_blank" rel="noopener noreferrer">신청하기 &gt;</a>
                        <span className='adSpan'>광고</span>
                        <span className='adDetail'> 광고상품입니다. 실제 구매가격은 할인율, 옵션 선택에 따라 달라질 수 있습니다.</span>
                    </div>
                    <div className='PowerShoppingAdList'>
                        <ul>
                            {powerShoppingList.length !== 0 && powerShoppingList?.map((v, i) => {
                                // props.setIsNaverLoading(false)
                                return (
                                    <li key={i}>
                                        <a href={v.clickUrl} target="_blank" rel="noopener noreferrer">
                                            <span className='PowerShoppingAdThumb'>
                                                <img
                                                    src={v.imageUrl}
                                                    alt="파워쇼핑 광고상품"
                                                    onLoad={() => (
                                                        checkADLoad()
                                                    )}
                                                />
                                            </span>
                                                <span className='PowerShoppingAdInfo'>
                                                    <span className='PowerShoppingAdInfoTitle'>{v.productTitle}</span>
                                                        <span className='PowerShoppingAdInfoPrice'><em>{numberFormat(v.minPrice)}</em>원</span>
                                                            <span className='PowerShoppingAdInfoMallName'><em>{v.mallName}</em>{v.naverPayIconType === 0 ? <i className='naverEmpty'></i> : (v.naverPayIconType === 1 ? <i className='naverPay'></i> : <i className='naverPayPlus'></i>)}</span>
                                                </span>
                                        </a>
                                    </li>
                                )
                            })}
                        </ul>
                    </div>
                </Case>
            ) : (
                <>
                    {
                        checkADLoad()
                    }
                </>
            )}
        </div>
    );
}
const Case = styled.div`
    display: block;
    position: relative;
    letter-spacing: -.5px;
    margin-bottom: 28px;

    & > .PowerShoppingAdTitle {
        margin-top: 15px;
        padding: 0 0 35px;
        position: relative;
        height: 20px;
        line-height: 20px;
        font-size: 16px;
        font-weight: bold;
        color: #000;
        border-bottom: 1px solid #666;
    }

    & > .PowerShoppingAdTitle > em {
        display: inline-block;
        padding-right: 28px;
        position: relative;
    }

    & > .PowerShoppingAdTitle > .adSpan {
        font-weight: bold;
        padding: 2px 8px 1px 8px !important;
        border: 1px solid #c8c8c8;
        font-size: 11px;
        line-height: 14px;
    }

    & > .PowerShoppingAdTitle > .adDetail {
        font-weight: normal;
        font-size: 12px;
    }

    & > .PowerShoppingAdTitle > a {
        float: right;
        color: #aaa;
        font-size: 12px;
        font-weight: normal;
        padding-right: 16px;

        &:hover {
            text-decoration: underline
        }
    }

    & > .PowerShoppingAdList {
        padding: 16px 0;
        position: relative;
        overflow: hidden;
        width: 100%;
    }

    & > .PowerShoppingAdList > ul {
        margin-left: -16px;
        width: 1026px;
        overflow: hidden;
    }

    & > .PowerShoppingAdList > ul > li {
        width: 142px;
        margin-left: 16px;
        position: relative;
        float: left;
    }

    & > .PowerShoppingAdList > ul > li > a {
        display: block;

        &:hover {
            text-decoration: underline
        }
    }

    & > .PowerShoppingAdList > ul > li > a > .PowerShoppingAdThumb {
        width: 142px;
        height: 142px;
        position: relative;
        display: block;
    }

    & > .PowerShoppingAdList > ul > li > a > .PowerShoppingAdThumb::before {
        content: "";
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        border: 1px solid rgba(0, 0, 0, .05);
        background: rgba(0, 0, 0, .015);
        pointer-events: none;
    }

    & > .PowerShoppingAdList > ul > li > a > .PowerShoppingAdThumb > img {
        width: 100%;
        height: 100%;
    }

    & > .PowerShoppingAdList > ul > li > a > .PowerShoppingAdInfo {
        display: block;
        padding: 8px 0 0;
        line-height: 20px;
        height: 95px;
    }

    & > .PowerShoppingAdList > ul > li > a > .PowerShoppingAdInfo > .PowerShoppingAdInfoTitle {
        display: block;
        font-size: 13px;
        height: 36px;
        line-height: 18px;
        color: #333;
        text-overflow: ellipsis;
        white-space: normal;
        word-wrap: break-word;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
        letter-spacing: 0;
    }

    & > .PowerShoppingAdList > ul > li > a > .PowerShoppingAdInfo > .PowerShoppingAdInfoPrice {
        display: block;
        font-size: 14px;
        color: #000;
        margin-top: 6px;
        color: blue;
    }

    & > .PowerShoppingAdList > ul > li > a > .PowerShoppingAdInfo > .PowerShoppingAdInfoPrice > em {
        font-size: 18px;
        font-weight: bold;
        vertical-align: -1px;
    }

    & > .PowerShoppingAdList > ul > li > a > .PowerShoppingAdInfo > .PowerShoppingAdInfoMallName {
        display: block;
        font-size: 12px;
        color: #666;
        margin-top: 8px;
    }

    & > .PowerShoppingAdList > ul > li > a > .PowerShoppingAdInfo > .PowerShoppingAdInfoMallName > em {
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        position: relative;
        display: inline-block;
        max-width: 95px;
    }

    & > .PowerShoppingAdList > ul > li > a > .PowerShoppingAdInfo > .PowerShoppingAdInfoMallName > .naverEmpty {
        margin-left: 4px;
        text-indent: -9999em;
        width: 30px;
        height: 17px;
        display: inline-block;
        position: relative;
        vertical-align: -1px;
    }

    & > .PowerShoppingAdList > ul > li > a > .PowerShoppingAdInfo > .PowerShoppingAdInfoMallName > .naverPay {
        margin-left: 4px;
        text-indent: -9999em;
        width: 33px;
        height: 17px;
        display: inline-block;
        position: relative;
        background: url("https://cdnimg.happyshopping.kr/img_static/img_naver/naverPay_33_13.png") no-repeat;
        vertical-align: -1px;
    }

    & > .PowerShoppingAdList > ul > li > a > .PowerShoppingAdInfo > .PowerShoppingAdInfoMallName > .naverPayPlus {
        margin-left: 4px;
        text-indent: -9999em;
        width: 42px;
        height: 17px;
        display: inline-block;
        position: relative;
        background: url("https://cdnimg.happyshopping.kr/img_static/img_naver/naverPayPlus_42_13.png") no-repeat;
        vertical-align: -1px;
    }
`
export default NaverPowerShopping



// WEBPACK FOOTER //
// ./src/estimate_list/components/naverPowerShopping/index.js